import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "./components/About";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import { CSSTransition } from "react-transition-group";
import "./App.css";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <CSSTransition classNames="transition-fade" timeout={500}>
              <Home />
            </CSSTransition>
          }
        />
        <Route
          path="/about"
          element={
            <CSSTransition classNames="transition-fade" timeout={500}>
              <About />
            </CSSTransition>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
